import styled from 'styled-components';

export const StyledSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75vh;

  @keyframes ldio-kudgc4zgrv {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .ldio-kudgc4zgrv div {
    left: 98px;
    top: 48px;
    position: absolute;
    animation: ldio-kudgc4zgrv linear 1.0204081632653061s infinite;
    background: #53638c;
    width: 4px;
    height: 32px;
    border-radius: 2px / 2.88px;
    transform-origin: 2px 52px;
  }
  .ldio-kudgc4zgrv div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -0.935374149659864s;
    background: #53638c;
  }
  .ldio-kudgc4zgrv div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -0.8503401360544218s;
    background: #45254d;
  }
  .ldio-kudgc4zgrv div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.7653061224489796s;
    background: #1f305a;
  }
  .ldio-kudgc4zgrv div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.6802721088435374s;
    background: #53638c;
  }
  .ldio-kudgc4zgrv div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.5952380952380952s;
    background: #45254d;
  }
  .ldio-kudgc4zgrv div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.5102040816326531s;
    background: #1f305a;
  }
  .ldio-kudgc4zgrv div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.4251700680272109s;
    background: #53638c;
  }
  .ldio-kudgc4zgrv div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.3401360544217687s;
    background: #45254d;
  }
  .ldio-kudgc4zgrv div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.25510204081632654s;
    background: #1f305a;
  }
  .ldio-kudgc4zgrv div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.17006802721088435s;
    background: #53638c;
  }
  .ldio-kudgc4zgrv div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.08503401360544217s;
    background: #45254d;
  }
  .ldio-kudgc4zgrv div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
    background: #1f305a;
  }
  .loadingio-spinner-spinner-vhpwil6ajrj {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    background: none;
  }
  .ldio-kudgc4zgrv {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-kudgc4zgrv div {
    box-sizing: content-box;
  }
`;
